
import { createApp } from "vue-demi";
import "bootstrap";
import "@vuepic/vue-datepicker/dist/main.css";

export default createApp({

})

